// extracted by mini-css-extract-plugin
export default {"FeedBackContainer":"FeedBack_FeedBackContainer__+xLSa","Show":"FeedBack_Show__b7HSf","Hide":"FeedBack_Hide__bGfhx","FeedBackInfo":"FeedBack_FeedBackInfo__D15lG"};